{
  "title": "Green-Flame Blade",
  "source": "Tasha's Cauldron of Everything/Sword Coast Adventurer's Guide",
  "levelAndSchool": "Evocation cantrip",
  "level": 0,
  "castingTime": "1 action",
  "range": "Self (5-foot radius)",
  "components": "S, M (a melee weapon worth at least 1 sp)",
  "duration": "Instantaneous",
  "description": [
    "You brandish the weapon used in the spell’s casting and make a melee attack with it against one creature within 5 feet of you. On a hit, the target suffers the weapon attack’s normal effects, and you can cause green fire to leap from the target to a different creature of your choice that you can see within 5 feet of it. The second creature takes fire damage equal to your spellcasting ability modifier.",
    "At Higher Levels. At 5th level, the melee attack deals an extra 1d8 fire damage to the target on a hit, and the fire damage to the second creature increases to 1d8 + your spellcasting ability modifier. Both damage rolls increase by 1d8 at 11th level (2d8 and 2d8) and 17th level (3d8 and 3d8)."
  ],
  "spellLists": [
    "artificer",
    "eldritch-knight",
    "arcane-trickster",
    "sorcerer",
    "warlock",
    "wizard"
  ]
}
